import { AppPhase } from '../types';
import {
  GRADING_ONLY_MODE,
  gradeEntryPhase,
  isGradingOnlyPhase,
  resolvePhaseForGradingOnly,
} from './gradingOnlyMode';
import { isAppShellEnabled, isAppShellPhase } from './appShellMode';
import { isDemoWorkflowEnabled } from './demoWorkflowMode';

/**
 * TEMP demo / showcase: Grade workspace only, no sign-in screen.
 * Enable with `VITE_DEMO_GRADE_ONLY=true` (e.g. `.env.local` or App Hosting BUILD env).
 * Revert: remove the env var (or set `false`) and redeploy — full app returns.
 *
 * Phase clamping is shared with {@link GRADING_ONLY_MODE} via {@link resolvePhaseForApp}.
 */
export const DEMO_GRADE_ONLY = import.meta.env.VITE_DEMO_GRADE_ONLY === 'true';

export { isGradingOnlyPhase as isDemoGradeOnlyPhase };

/** Clamp phases when demo or grading-only product flag is active. */
export function resolvePhaseForApp(phase: AppPhase): AppPhase {
  if (DEMO_GRADE_ONLY || GRADING_ONLY_MODE) {
    // App-shell phases pass through only when VITE_APP_SHELL is enabled.
    if (isAppShellEnabled() && isAppShellPhase(phase)) return phase;
    // The demo workflow phase passes through only when BOTH the app shell and
    // the demo-workflow flag are enabled (Onboarding 1C); otherwise it clamps
    // away like any other non-grade phase.
    if (isAppShellEnabled() && isDemoWorkflowEnabled() && phase === AppPhase.DEMO_WORKFLOW) {
      return phase;
    }
    return isGradingOnlyPhase(phase) ? phase : gradeEntryPhase();
  }
  return phase;
}

/** @deprecated Use {@link resolvePhaseForApp} */
export function resolvePhaseForDemo(phase: AppPhase): AppPhase {
  return resolvePhaseForApp(phase);
}

export { resolvePhaseForGradingOnly };
